import { create } from 'zustand'

type FilterState = {
    selectedColors: string | null
    setColors: (colors: string | null ) => void
    // toggleColor: (color: string) => void
    // clearColors: () => void

    selectedSize: string | null
    setSize: (size: string | null) => void
    //   setSizes:
    //   toggleSize

    selectedSections: string[]
    setSections: (v: string[]) => void
    toggleSection: (v: string) => void

    selectedGenders: string[]
    setGenders: (v: string[]) => void
    toggleGender: (v: string) => void

    selectedSeasons: string[]
    setSeasons: (v: string[]) => void
    toggleSeason: (v: string) => void

    priceMin?: number | null
    priceMax?: number | null

    setPrice: (min: number, max: number) => void
    resetFilters?: () => void

    available?: boolean // true = "В наличии", false = "Все товары"
    setAvailable: (val: boolean) => void
}

export const useFilterStore = create<FilterState>((set, get) => ({
    selectedColors: null,


    setColors: (colors) => set({ selectedColors: colors }),
    // toggleColor: (color) => {
    //     const cur = get().selectedColors
    //     if (cur.includes(color)) {
    //         set({ selectedColors: cur.filter((c) => c !== color) })
    //     } else {
    //         set({ selectedColors: [...cur, color] })
    //     }
    // },
    // clearColors: () => set({ selectedColors: [] }),


    selectedSize: null,
    setSize: (size) => set({ selectedSize: size }),
    // toggleSize: (size) =>
    //     set((state) => ({
    //         selectedSizes: state.selectedSizes.includes(size)
    //             ? state.selectedSizes.filter((s) => s !== size)
    //             : [...state.selectedSizes, size],
    //     })),

    // SECTIONS (Разделы)
    selectedSections: [],
    setSections: (v) => set({ selectedSections: v }),
    toggleSection: (v) =>
        set((state) => ({
            selectedSections: state.selectedSections.includes(v)
                ? state.selectedSections.filter((s) => s !== v)
                : [...state.selectedSections, v],
        })),

    // GENDER
    selectedGenders: [],
    setGenders: (v) => set({ selectedGenders: v }),
    toggleGender: (v) =>
        set((state) => ({
            selectedGenders: state.selectedGenders.includes(v)
                ? state.selectedGenders.filter((s) => s !== v)
                : [...state.selectedGenders, v],
        })),

    // SEASON
    selectedSeasons: [],
    setSeasons: (v) => set({ selectedSeasons: v }),
    toggleSeason: (v) =>
        set((state) => ({
            selectedSeasons: state.selectedSeasons.includes(v)
                ? state.selectedSeasons.filter((s) => s !== v)
                : [...state.selectedSeasons, v],
        })),
    
    priceMin: 110,
    priceMax: 49900,
    setPrice: (min, max) => set({ priceMin: min, priceMax: max }),

    available: undefined, 
    setAvailable: (val: boolean) => set({ available: val }),
}))


